import * as React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Dimensions } from 'react-native';
import theme, { Icon, Colors } from '@qnpm/q-theme';
import Circle from './common/Circle';
import { Shadow } from '@qnpm/q-shadow';
const { scenes: { baseColor } } = Colors;
const { font, responsive: { scale } } = theme;
const SCREEN_HEIGHT = Dimensions.get('screen').height;
const SCREEN_WIDTH = Dimensions.get('screen').width;
export default class FullCircle extends React.PureComponent {
    render() {
        const { text, showClose, onClose, customStyle = {} } = this.props;
        const { maskWrapperStyle = {} } = customStyle || {};
        return (<View style={[
            styles.wrapper,
            typeof maskWrapperStyle === 'object' ? maskWrapperStyle : {}
        ]}>
                <Shadow shadow="shadow3" shadowPosition="all" style={styles.container}>
                    {showClose ? (<TouchableOpacity activeOpacity={1} onPress={() => typeof onClose === 'function' && onClose()} style={styles.iconCon}>
                            <Icon needScale name="close" size={14} color="#9E9E9E"/>
                        </TouchableOpacity>) : null}
                    <Circle />
                    <View style={styles.textWrapper}>
                        <Text numberOfLines={1} style={styles.text}>
                            {text || '加载中'}
                        </Text>
                    </View>
                </Shadow>
            </View>);
    }
}
const styles = StyleSheet.create({
    wrapper: {
        width: SCREEN_WIDTH,
        height: SCREEN_HEIGHT,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.40)'
    },
    container: {
        width: scale(110),
        height: scale(100),
        backgroundColor: '#fff',
        borderRadius: 5,
        alignItems: 'center',
        justifyContent: 'center'
    },
    textWrapper: {
        width: scale(80),
        marginTop: 12,
        alignItems: 'center'
    },
    text: {
        fontSize: font.size.scaled.fontSizeM,
        color: baseColor.text2,
        lineHeight: scale(20),
        textAlign: 'center'
    },
    iconCon: {
        position: 'absolute',
        top: 6,
        right: 6
    }
});
